import React from 'react';
import { styled } from 'baseui';
import { Accordion, Panel } from 'baseui/accordion';
import { Button, KIND, SHAPE } from 'baseui/button';
import { Card } from 'baseui/card';
import { FormControl } from 'baseui/form-control';
import { Plus, TrashCanFilled } from 'baseui/icon';
import { Input } from 'baseui/input';
import { StyledLink } from 'baseui/link';
import { Textarea } from 'baseui/textarea';
import { HeadingXSmall } from 'baseui/typography';
import type { QuestionnaireInputT } from '../../../types/questionnaireInput';
type ProjectQuestionnaireProps = {
  questionnaires: QuestionnaireInputT[];
  setQuestionnaires: React.Dispatch<React.SetStateAction<QuestionnaireInputT[]>>;
};
const Container = styled('div', ({
  $theme
}) => ({
  marginBottom: $theme.sizing.scale600
}));
const validateJson = (str: string) => {
  if (str === '') {
    return 'JSON is required';
  }
  try {
    JSON.parse(str);
  } catch (e) {
    return 'Invalid JSON';
  }
  return '';
};
const ProjectQuestionnaire = (props: ProjectQuestionnaireProps) => {
  const {
    questionnaires,
    setQuestionnaires
  } = props;
  return <Container>
      <Card>
        <HeadingXSmall style={{
        margin: '0'
      }}>
          Questionnaire{' '}
          <Button shape={SHAPE.circle} kind={KIND.tertiary} onClick={() => {
          setQuestionnaires([...questionnaires, {
            data: '',
            name: '',
            questionnaireId: crypto.randomUUID()
          }]);
        }}>
            <Plus />
          </Button>
        </HeadingXSmall>
        <Accordion>
          {questionnaires.map((questionnaire, index) => <Panel title={<div>
                  <span>Questionnaire {questionnaire.name}</span>
                  <Button shape={SHAPE.circle} kind={KIND.tertiary} onClick={() => {
            const newQuestionnaires = [...questionnaires];
            newQuestionnaires.splice(index, 1);
            setQuestionnaires(newQuestionnaires);
          }}>
                    <TrashCanFilled />
                  </Button>
                </div>} key={index}>
              <FormControl label="Name" error={questionnaire.name === '' ? 'Name is required' : ''}>
                <Input value={questionnaire.name} onChange={e => {
              const newQuestionnaires = [...questionnaires];
              // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
              newQuestionnaires[index].name = e.currentTarget.value;
              setQuestionnaires(newQuestionnaires);
            }} placeholder="Enter name for questionnaire" />
              </FormControl>
              <FormControl label="Questionnaire JSON" error={validateJson(questionnaire.data)}>
                <div>
                  <div>
                    Generate questionnaire from{' '}
                    <StyledLink target="_blank" rel="noopener" href="https://questions.uberinternal.com">
                      https://questions.uberinternal.com
                    </StyledLink>{' '}
                    and paste JSON below
                  </div>
                  <Textarea value={questionnaire.data} error={!!validateJson(questionnaire.data)} onChange={e => {
                if (validateJson(e.currentTarget.value) === 'Invalid JSON') {
                  return;
                }
                const newQuestionnaires = [...questionnaires];
                // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
                newQuestionnaires[index].data = e.currentTarget.value;
                setQuestionnaires(newQuestionnaires);
              }} placeholder="Enter questionnaire" />
                </div>
              </FormControl>
            </Panel>)}
        </Accordion>
      </Card>
    </Container>;
};
export default ProjectQuestionnaire;